//TODO: export these from stylovyze
export const em = (px: number, basePx = 16) => `${px / basePx}em`;
export const rem = (px: number, basePx = 16) => `${px / basePx}rem`;
